import { AxiosInstance } from "axios";

export default class ViewOrderItemService {
  private _endpoint = "ViewOrderItem";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public async GetSummary(
    orderItemId: string,
    layerName: string,
  ): Promise<any> {
    return this._client
      .get<any>(
        `${this._endpoint}/${encodeURIComponent(layerName)}/${orderItemId}/summary`,
      )
      .then((response) => response.data);
  }
}
